import { TPaletteStatus } from '@mui/material/styles';
import styled, { css } from 'styled-components';

import { TJobStatusStyledIconContainerProps } from '@/console/features/jobs/components/job-status-styled-icon/job-status-styled-icon.types';
import { getBorderStyle } from '@/shared/components/ui/button/common/button-common.styled';

export const getJobStatusStyles = ($status: keyof TPaletteStatus = 'grey') => {
  return css`
    border-radius: 100%;

    svg {
      height: 1rem;
      width: 1rem;
    }

    ${({ theme }) => css`
      color: ${theme.palette.status[$status].text};
      background-color: ${theme.palette.status[$status].background};
      ${getBorderStyle(theme.palette.status[$status].stroke)};

      svg {
        color: ${theme.palette.status[$status].text};
      }
    `}
  `;
};

export const JobStatusStyledIconContainer = styled.span<TJobStatusStyledIconContainerProps>`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;

    ${({ $status }) => getJobStatusStyles($status)};
  }
`;
